module.exports = __webpack_public_path__ + "img/detail.7b32f70e.png";